import styled, { css } from "styled-components";
import Select from "../Select/Select";

export const DropdownRoot = styled(Select)(
    ({ theme: { spacing } }) => css`
        .Select {
            .SelectMenu {
                padding: ${spacing.vertical(4)};
            }
            .DisplayContent {
                white-space: unset;
            }
        }
    `,
) as typeof Select;
